import { database } from './firebase';

export interface IRanking {
  name: string;
  score: number;
  star: number;
  uid: string;
}

const fetch = async (limit: number) => {
  const snapshot = await database
    .collection('ranking')
    .doc('game')
    .collection('allTime')
    .limit(limit)
    .orderBy('score', 'desc')
    .get();
  return snapshot.docs.map((doc) => doc.data() as IRanking);
};

export { fetch };
